// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://rqgrxjbsaymzkbvrtwpb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJxZ3J4amJzYXltemtidnJ0d3BiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk1NDU3OTksImV4cCI6MjA2NTEyMTc5OX0.E1tdhcHEIqLP_rbGbOpoL7rI7wQaCW2Y60aGuN-1qnk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);